import React, { Component } from "react"
import { Container, Row } from 'reactstrap';

import Prefectures from './data_exploration/Prefectures.js';
import Prefecture from './data_exploration/Prefecture.js';

class DataExploration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      province: null,
      prefecture: null,
      prefectureGeo: null,
      category: null
    };
  }

  updateDataExplorer(newState) {
    this.setState(newState); 
  }

  render () {
    if(this.state.prefecture) {
      return (
        <Prefecture 
          province={this.state.province}
          prefecture={this.state.prefecture} 
          prefectureGeo={this.state.prefectureGeo}
          category={this.state.category}
          updateDataExplorer={this.updateDataExplorer.bind(this)}/>
      ); 
    } else {
      return (
        <Prefectures 
          province={this.state.province}
          prefectureGeo={this.state.prefectureGeo}
          updateDataExplorer={this.updateDataExplorer.bind(this)}/>
      );  
    }
  }
}

export default DataExploration
